import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { Select, Card, Typography, Divider, Descriptions, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

function PanchayatDetails() {
  const [panchayatList, setPanchayatList] = useState([]);
  const [selectedPanchayat, setSelectedPanchayat] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch Panchayat details
  const getPanchayatDetails = async () => {
    try {
      const response = await dataService.getPanchayatBasedAdmin();
      const fetchedPanchayats = response.data;
      setPanchayatList(fetchedPanchayats);

      if (fetchedPanchayats.length > 0) {
        setSelectedPanchayat(fetchedPanchayats[0]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPanchayatDetails();
  }, []);

  // Handle panchayat selection
  const handlePanchayatSelect = (panchayatId) => {
    // const panchayat = panchayatList.find((p) => p._id === panchayatId);
    // setSelectedPanchayat(panchayat);
    getPanchayatDetailsById(panchayatId);
  };

  const getPanchayatDetailsById = async (id) => {
    try {
      const response = await dataService.getPanchayatBasedAdminId(id);
      setSelectedPanchayat(response.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "30px 20px", backgroundColor: "#f7f7f7" }}>
      {/* Panchayat Select Dropdown */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          placeholder="Select a Panchayat"
          style={{
            width: 300,
            // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            // borderRadius: "4px",
            // padding: "5px 10px",
            border: "1px solid grey",
            borderRadius: 5,
          }}
          value={selectedPanchayat?._id}
          onChange={handlePanchayatSelect}
          loading={loading}
        >
          <Select.Option disabled>Select Panchayat</Select.Option>
          {panchayatList.map((panchayat) => (
            <Select.Option key={panchayat._id} value={panchayat._id}>
              {panchayat.panchayatName}
            </Select.Option>
          ))}
        </Select>
      </div>

      {/* Display details of the selected Panchayat */}
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spin size="large" />
        </div>
      ) : (
        selectedPanchayat && (
          <Card
            style={{
              marginTop: 20,
              borderRadius: "8px",
              boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
            }}
            title={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.4em",
                  fontWeight: "500",
                  color: "#595959",
                }}
              >
                <InfoCircleOutlined
                  style={{ marginRight: "10px", color: "#1890ff" }}
                />
                Panchayat Information
              </span>
            }
            bordered={true}
          >
            <Divider />

            {/* Descriptions displaying Panchayat info */}
            <Descriptions bordered column={1} style={{ fontSize: "1em" }}>
              <Descriptions.Item label="Panchayat Name">
                <Text strong>{selectedPanchayat.panchayatName}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Assembly Name">
                <Text>{selectedPanchayat.assemblyName}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Booth">
                <Text>{selectedPanchayat.totalBooth}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Population">
                <Text>{selectedPanchayat.totalPopulation}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Voters">
                <Text>{selectedPanchayat.totalVoters}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Male Voters">
                <Text>{selectedPanchayat.totalMaleVoter}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Total Female Voters">
                <Text>{selectedPanchayat.totalFemaleVoter}</Text>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )
      )}
    </div>
  );
}

export default PanchayatDetails;
